import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-proyects',
  templateUrl: './proyects.component.html',
  styleUrls: ['./proyects.component.scss']
})
export class ProyectsComponent implements OnInit {
  Projects = [

    {
      
      imgs:[
        // '../../../../assets/images/commerce-platform/admin/9.PNG',
        // '../../../../assets/images/commerce-platform/admin/1.PNG',
        // '../../../../assets/images/commerce-platform/admin/2.PNG',
        // '../../../../assets/images/commerce-platform/admin/3.PNG',
        // '../../../../assets/images/commerce-platform/admin/4.PNG',
        // '../../../../assets/images/commerce-platform/admin/5.PNG',
        // '../../../../assets/images/commerce-platform/admin/6.PNG',
        // '../../../../assets/images/commerce-platform/admin/7.PNG',
        // '../../../../assets/images/commerce-platform/admin/8.PNG',



        '../../../../assets/images/commerce-platform/employee/5.PNG',
        '../../../../assets/images/commerce-platform/employee/1.PNG',
        '../../../../assets/images/commerce-platform/employee/2.PNG',
        '../../../../assets/images/commerce-platform/employee/3.PNG',
        '../../../../assets/images/commerce-platform/employee/4.PNG',


        // '../../../../assets/images/commerce-platform/applicant/5.PNG',
        // '../../../../assets/images/commerce-platform/applicant/1.PNG',
        // '../../../../assets/images/commerce-platform/applicant/2.PNG',
        // '../../../../assets/images/commerce-platform/applicant/3.PNG',
        // '../../../../assets/images/commerce-platform/applicant/4.PNG',
       




        ],
      Title:'TripsnHub',
      Description:`we designed and developed a comprehensive online platform for travel and booking
      This platform is for customers to book there trip throw online.
      It,s also very helpfull for the customers to sortout there preferred trip`,
      Technologies:['Vue.js','CSS', 'Strapi-CMS'],
      ghLink:'',
      demoLink:'https://www.tripsnhub.com/'
    },





    {
      
      imgs:[
        // '../../../../assets/images/church/2.PNG',
        // '../../../../assets/images/church/Capture.PNG',
        // '../../../../assets/images/church/10.PNG',
        '../../../../assets/images/church/1.PNG',
        '../../../../assets/images/church/2.PNG',
        '../../../../assets/images/church/3.PNG',
        '../../../../assets/images/church/4.PNG',
        // '../../../../assets/images/church/7.PNG',
        // '../../../../assets/images/church/8.PNG',
        // '../../../../assets/images/church/9.PNG',

        ],
      Title:'A Church Website',
      Description:"A website for a church in thrissur. Which uses strapi cms. The content can be switch into multiple languages",
      Technologies:['Angular','SCSS','Angular-Primeng' ,'Strapi', 'Angular-Prime-Blocks'],
      ghLink:'',
      demoLink:'https://stjudelatinchurch.in/#/'
    },




    // {
      
    //   imgs:[
    //     '../../../../assets/images/medmatch/screenshot.png',
    //     '../../../../assets/images/medmatch/screenshot (1).png',
    //     '../../../../assets/images/medmatch/screenshot (2).png',
    //     '../../../../assets/images/medmatch/screenshot (3).png'],
    //   Title:'Med Match',
    //   Description:'The purpose of this project is to enhance the safety of prescribing drugs and to address the challenges related to prescribing errors which can have significant damage the patient’s health, the project ultimate goal is to contribute to the overall improvement of medication safety in the healthcare department.',
    //   Technologies:['Angular','SCSS','Angular-Material' , 'RxJS', 'Node.js'],
    //   ghLink:'https://github.com/loayeldin/medmatch',
    //   demoLink:'https://www.kamair.com/'
    // },





    {
      imgs:[
        '../../../../assets/images/kamair/1.PNG',
        '../../../../assets/images/kamair/2.PNG',
        '../../../../assets/images/kamair/3.PNG',
        '../../../../assets/images/kamair/4.PNG',
      ],
      Title:'Kamair',
      Description:'we designed and developed a comprehensive online platform for travel and booking This platform is for customers to book there trip throw online.It,s also very helpfull for the customers to sortout there preferred trip',
      Technologies:['Vue.js','Nuxt.js','CSS','Prime-Vue','Strapi-CMS'],
      // ghLink:'https://github.com/loayeldin/bahie-portfolio', 
      demoLink:'https://www.kamair.com/'
    },













    {
      imgs:[
        '../../../../assets/images/Fairfuture/1.png',
        '../../../../assets/images/Fairfuture/2.png',
        '../../../../assets/images/Fairfuture/3.png',
        '../../../../assets/images/Fairfuture/4.png',
        '../../../../assets/images/Fairfuture/5.png',
      ],
      Title:'Fair Future Website',
      Description:'we designed and developed a comprehensive online platform for travel and booking This platform is for customers to book there trip throw online.It,s also very helpfull for the customers to sortout there preferred trip.',
      Technologies:['Vue.js','Nuxt.js','CSS' , 'Strapi'],
      // ghLink:'https://github.com/loayeldin/dynamic-todo-app',
      demoLink:'https://www.fairfuturetravels.com/'
    },
    // {
    //   imgs:[
      
    //     '../../../../assets/images/recipe-book/screenshot (1).png',
    //     '../../../../assets/images/recipe-book/screenshot (2).png',
    //     '../../../../assets/images/recipe-book/screenshot (3).png',
    //   ],
    //   Title:'Recipe Book',
    //   Description:'Users can add new recipes to their collection and categorize them based on different types of cuisines or meal types. Each recipe includes a comprehensive list of ingredients required for the dish, making it convenient for users to shop for the necessary items.',
    //   Technologies:['Angular','Css','Angular-Material' , 'RxJS','firebase'],
    //   ghLink:'https://github.com/loayeldin/recipe-book',
    //   demoLink:'https://recipe-book-theta-blue.vercel.app'
    // },
    // {
    //   imgs:[
    //     '../../../../assets/images/design-show/1.png',
    //     '../../../../assets/images/design-show/2.png',
    //     '../../../../assets/images/design-show/4.PNG',
    //   ],
    //   Title:'Design Show',
    //   Description:'Design Show provides a user-friendly interface that enables artists and designers to upload high-quality images and multimedia content, along with detailed project descriptions. This allows viewers to explore the creative process and context behind each artwork.',
    //   Technologies:['Html','SCSS','JavaScript' , 'Jquery', 'animation-libraries'],
    //   ghLink:'',
    //   demoLink:'https://design-show.netlify.app/'
    // },

  
    // {
    //   imgs:[
      
    //     '../../../../assets/images/typing-speed/1.png',
   
    //   ],
    //   Title:'Typing Speed Test',
    //   Description:` The application measures the number of words or characters typed per minute (words per minute - WPM or characters per minute - CPM) to determine the user's typing speed. In addition to speed, the test evaluates typing accuracy by calculating the number of errors made during the typing exercise.`,
    //   Technologies:['Html','CSS','JavaScript' , 'Jquery'],
    //   ghLink:'https://github.com/loayeldin/typing-speed-test',
    //   demoLink:'https://typingspeedgamee.netlify.app/'
    // },

    


  ]
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 900,
    items: 1,
    autoplay: true,
    autoplayTimeout:3000
  }

  @ViewChild('imgContainer') imgContainer: ElementRef;


  constructor(
    public analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {



  }

debug(){

  this.imgContainer.nativeElement.scroll({
    top: this.imgContainer.nativeElement.scrollHeight,
    left: 0,
    behavior: 'smooth',    
  });
}

}
